import { useStore } from 'app/context';
import { ImportDataType } from 'app/stores/admin.imports.store';
import { AggregateFunction, AgtAnalyticsStore, IBmCount, ITimeSeriesWithStats, IFieldBmQuality, IVntrBmCountQuality, TimeDimension } from 'app/stores/agt.analytics.store';
import { useEffect, useMemo, useState, useRef } from 'react';
import { ITableColumn, TableModel } from '../table/table.model';
import { Table } from '../table/table';
import { observer } from 'mobx-react';
import { formatNum } from 'app/utils';
import { init, EChartsOption } from 'echarts';

interface IShowBmForDataType {
	dataType: ImportDataType;
}

export const ShowBmDataQualtiyForDataType = observer((props: IShowBmForDataType) => {
	const {
		agtGoogleProfileStore,
		agtKvmStore,
		agtAmisNowStore,
		agtFacebookStore,
		agtInstagramStore,
		agtDigitalReportStore,
		agtTiktokStore,
		agtLinkedinStore,
		agtLeadNowStore,
		agtAkumaPrimeStore,
		agtAkumaPlanerStore,
		agtAkumaAktionenStore,
		agtStsStore,
		agtClusterStore,
	} = useStore();

	switch (props.dataType) {
		case ImportDataType.googleprofile:
			return (
				<>
					<VntrControlChart store={agtGoogleProfileStore} title="Anz. VTNR pro Monat" />
					<MultiFieldControlChart
						store={agtGoogleProfileStore}
						fields={[
							{ fieldName: 'bewertungen', aggregateFunc: AggregateFunction.AVG, label: 'Bewertungen' },
							{ fieldName: 'bewertungsdurchschnitt', aggregateFunc: AggregateFunction.AVG, label: 'Bewertungsdurchschnitt' },
						]}
					/>
				</>
			);
		case ImportDataType.kvm:
			return (
				<>
					<VntrControlChart store={agtKvmStore} title="Anz. VTNR pro Monat" />
					<MultiFieldControlChart
						store={agtKvmStore}
						fields={[
							{ fieldName: 'anzahl_anrufe_gesamt', aggregateFunc: AggregateFunction.SUM, label: 'Anrufe Gesamt (Summe)' },
							{ fieldName: 'anzahl_anrufe_gesamt', aggregateFunc: AggregateFunction.AVG, label: 'Anrufe Gesamt (Ø)' },
							{ fieldName: 'anzahl_anrufe_waehrend_servicezeiten', aggregateFunc: AggregateFunction.SUM, label: 'Anrufe Servicezeiten (Summe)' },
							{ fieldName: 'anzahl_anrufe_waehrend_servicezeiten', aggregateFunc: AggregateFunction.AVG, label: 'Anrufe Servicezeiten (Ø)' },
							{ fieldName: 'ziel1_schaden', aggregateFunc: AggregateFunction.SUM, label: 'Ziel 1 Schaden (Summe)' },
							{ fieldName: 'ziel1_schaden', aggregateFunc: AggregateFunction.AVG, label: 'Ziel 1 Schaden (Ø)' },
							{ fieldName: 'ziel2_vertragsanliegen', aggregateFunc: AggregateFunction.SUM, label: 'Ziel 2 Vertragsanliegen (Summe)' },
							{ fieldName: 'ziel2_vertragsanliegen', aggregateFunc: AggregateFunction.AVG, label: 'Ziel 2 Vertragsanliegen (Ø)' },
							{ fieldName: 'ziel3_sonstige_anliegen', aggregateFunc: AggregateFunction.SUM, label: 'Ziel 3 Sonstige Anliegen (Summe)' },
							{ fieldName: 'ziel3_sonstige_anliegen', aggregateFunc: AggregateFunction.AVG, label: 'Ziel 3 Sonstige Anliegen (Ø)' },
							{ fieldName: 'ziel3_dann_retoure', aggregateFunc: AggregateFunction.SUM, label: 'Ziel 3 Dann Retoure (Summe)' },
							{ fieldName: 'ziel3_dann_retoure', aggregateFunc: AggregateFunction.AVG, label: 'Ziel 3 Dann Retoure (Ø)' },
							{ fieldName: 'retoure', aggregateFunc: AggregateFunction.SUM, label: 'Retoure (Summe)' },
							{ fieldName: 'retoure', aggregateFunc: AggregateFunction.AVG, label: 'Retoure (Ø)' },
							{ fieldName: 'keine_taste', aggregateFunc: AggregateFunction.SUM, label: 'Keine Taste (Summe)' },
							{ fieldName: 'keine_taste', aggregateFunc: AggregateFunction.AVG, label: 'Keine Taste (Ø)' },
							{ fieldName: 'schnellaufleger', aggregateFunc: AggregateFunction.SUM, label: 'Schnellaufleger (Summe)' },
							{ fieldName: 'schnellaufleger', aggregateFunc: AggregateFunction.AVG, label: 'Schnellaufleger (Ø)' },
						]}
					/>
				</>
			);
		case ImportDataType.sts:
			return (
				<>
					<VntrControlChart store={agtStsStore} title="Anz. VTNR pro Monat" />
					<MultiFieldControlChart
						store={agtStsStore}
						fields={[
							{ fieldName: 'basic', aggregateFunc: AggregateFunction.AVG, label: 'Basic (Ø)' },
							{ fieldName: 'basic', aggregateFunc: AggregateFunction.SUM, label: 'Basic (Summe)' },
							{ fieldName: 'mc', aggregateFunc: AggregateFunction.AVG, label: 'MC (Ø)' },
							{ fieldName: 'mc', aggregateFunc: AggregateFunction.SUM, label: 'MC (Summe)' },
						]}
					/>
				</>
			);
		case ImportDataType.agenturcluster:
			return (
				<>
					<VntrControlChart store={agtClusterStore} title="Anz. VTNR pro Jahr" />
					<MultiFieldControlChart
						store={agtClusterStore}
						fields={[
							{ fieldName: 'ub', aggregateFunc: AggregateFunction.SUM, label: 'UB (Summe)' },
							{ fieldName: 'vbl', aggregateFunc: AggregateFunction.SUM, label: 'VBL (Summe)' },
							{ fieldName: 'bsg', aggregateFunc: AggregateFunction.SUM, label: 'BSG (Summe)' },
							{ fieldName: 'vas', aggregateFunc: AggregateFunction.SUM, label: 'VAS (Summe)' },
							{ fieldName: 'kvs', aggregateFunc: AggregateFunction.SUM, label: 'KVS (Summe)' },
							{ fieldName: 'kme', aggregateFunc: AggregateFunction.SUM, label: 'KME (Summe)' },
							{ fieldName: 'bbs', aggregateFunc: AggregateFunction.SUM, label: 'BBS (Summe)' },
							{ fieldName: 'bfe', aggregateFunc: AggregateFunction.SUM, label: 'BFE (Summe)' },
							{ fieldName: 'fb', aggregateFunc: AggregateFunction.SUM, label: 'FB (Summe)' },
						]}
					/>
				</>
			);
		case ImportDataType.facebook:
			return (
				<>
					<VntrControlChart store={agtFacebookStore} title="Anz. VTNR pro Monat" />
					<MultiFieldControlChart
						store={agtFacebookStore}
						fields={[
							{ fieldName: 'fananzahl', aggregateFunc: AggregateFunction.AVG, label: 'Fananzahl' },
							{ fieldName: 'abonnenten', aggregateFunc: AggregateFunction.AVG, label: 'Abonnenten' },
							{ fieldName: 'postinganzahl', aggregateFunc: AggregateFunction.AVG, label: 'Postinganzahl' },
							{ fieldName: 'sichtkontakte', aggregateFunc: AggregateFunction.AVG, label: 'Sichtkontakte' },
							{ fieldName: 'vt_eigene_posts', aggregateFunc: AggregateFunction.AVG, label: 'Eigene Posts' },
						]}
					/>
				</>
			);
		case ImportDataType.instagram:
			return (
				<>
					<VntrControlChart store={agtInstagramStore} title="Anz. VTNR pro Monat" />
					<MultiFieldControlChart
						store={agtInstagramStore}
						fields={[
							{ fieldName: 'follower', aggregateFunc: AggregateFunction.AVG, label: 'Follower' },
							{ fieldName: 'views', aggregateFunc: AggregateFunction.AVG, label: 'Ansichten' },
							{ fieldName: 'postinganzahl', aggregateFunc: AggregateFunction.AVG, label: 'Postinganzahl' },
						]}
					/>
				</>
			);
		// case ImportDataType.digitalreport:
		//     return <>
		//         <VntrControlChart store={agtDigitalReportStore} title="Anz. VTNR pro Monat" />
		//         <MultiFieldControlChart
		//             store={agtDigitalReportStore}
		//             fields={[
		//                 { fieldName: 'anz_knd', aggregateFunc: AggregateFunction.SUM, label: 'Anz. Kunden' },
		//                 { fieldName: 'anz_digital_id', aggregateFunc: AggregateFunction.SUM, label: 'Anz. Digital ID' },
		//                 { fieldName: 'anz_maz', aggregateFunc: AggregateFunction.SUM, label: 'Anz. MAZ' },
		//             ]}
		//         />
		//     </>;
		case ImportDataType.amisnow:
			return (
				<>
					<VntrControlChart store={agtAmisNowStore} title="Anz. VTNR pro Monat" />
					<MultiFieldControlChart
						store={agtAmisNowStore}
						fields={[
							{ fieldName: 'summe', aggregateFunc: AggregateFunction.AVG, label: 'Summe Aufgaben' },
							{ fieldName: 'davon_read', aggregateFunc: AggregateFunction.AVG, label: 'Davon gelesen' },
							{ fieldName: 'abs_tkh', aggregateFunc: AggregateFunction.AVG, label: 'Telefonie KVM Halle Kunde' },
							{ fieldName: 'akuma', aggregateFunc: AggregateFunction.AVG, label: 'Aufgabe aus AKUMA' },
							{ fieldName: 'azamservices', aggregateFunc: AggregateFunction.AVG, label: 'Kundennachricht Vertriebschance' },
							{ fieldName: 'dssk', aggregateFunc: AggregateFunction.AVG, label: 'DSSK' },
							{ fieldName: 'amisnow_postkorb', aggregateFunc: AggregateFunction.AVG, label: 'AMIS.NOW Postkorb' },
							{ fieldName: 'gomservice', aggregateFunc: AggregateFunction.AVG, label: 'Freigabe Angebot' },
							{ fieldName: 'leadmachine', aggregateFunc: AggregateFunction.AVG, label: 'Kundennachricht Serviceanliegen' },
							{ fieldName: 'meineallianz', aggregateFunc: AggregateFunction.AVG, label: 'Meine Allianz Nachricht' },
							{ fieldName: 'tkh_interessent', aggregateFunc: AggregateFunction.AVG, label: 'Telefonie KVM Halle Interessent' },
							{ fieldName: 'manual', aggregateFunc: AggregateFunction.AVG, label: 'Eigene Aufgaben' },
							{ fieldName: 'meingeld', aggregateFunc: AggregateFunction.AVG, label: 'Vertriebschance Wiederanlage' },
						]}
					/>
				</>
			);
		// case ImportDataType.tiktok:
		//     return <>
		//         <VntrControlChart store={agtTiktokStore} title="Anz. VTNR pro Monat" />
		//         <MultiFieldControlChart
		//             store={agtTiktokStore}
		//             fields={[
		//                 { fieldName: 'follower', aggregateFunc: AggregateFunction.AVG, label: 'Follower' },
		//                 { fieldName: 'sichtkontakte', aggregateFunc: AggregateFunction.SUM, label: 'Sichtkontakte' },
		//                 { fieldName: 'postinganzahl', aggregateFunc: AggregateFunction.SUM, label: 'Postinganzahl' },
		//             ]}
		//         />
		//     </>;
		// case ImportDataType.linkedin:
		//     return <>
		//         <VntrControlChart store={agtLinkedinStore} title="Anz. VTNR pro Monat" />
		//         <MultiFieldControlChart
		//             store={agtLinkedinStore}
		//             fields={[
		//                 { fieldName: 'follower', aggregateFunc: AggregateFunction.AVG, label: 'Follower' },
		//                 { fieldName: 'sichtkontakte', aggregateFunc: AggregateFunction.SUM, label: 'Sichtkontakte' },
		//                 { fieldName: 'postinganzahl', aggregateFunc: AggregateFunction.SUM, label: 'Postinganzahl' },
		//             ]}
		//         />
		//     </>;
		case ImportDataType.leadnow:
			const agtStatuses = ['a', 'd', 'i', 'm', 'v'];

			return (
				<>
					<VntrControlChart store={agtLeadNowStore} title="Anz. VTNR pro KW" timeDimension="kw" where="kw >202501" />
					<MultiFieldControlChart
						store={agtLeadNowStore}
						timeDimension="kw"
						fields={[{ fieldName: 'agenturstatus', aggregateFunc: AggregateFunction.COUNT_DISTINCT, label: 'Anz Agenturstatus', where: 'kw >202501' }]}
					/>
					<MultiFieldControlChart
						store={agtLeadNowStore}
						timeDimension="kw"
						fields={agtStatuses.map((s) => {
							return {
								fieldName: 'agenturstatus',
								aggregateFunc: AggregateFunction.COUNT,
								label: 'Anz Agenturstatus=' + s,
								where: "a.agenturstatus='" + s + "' and kw > 202501",
							};
						})}
					/>
					<MultiFieldControlChart
						store={agtLeadNowStore}
						timeDimension="kw"
						fields={[
							{
								fieldName: 'agenturstatus',
								aggregateFunc: AggregateFunction.COUNT,
								label: 'Anz Agenturstatus= undefiniert',
								where: 'agenturstatus not in (' + agtStatuses.map((x) => "'" + x + "'").join(',') + ')',
							},
						]}
					/>
					<MultiFieldControlChart
						store={agtLeadNowStore}
						timeDimension="kw"
						fields={[
							{ fieldName: 'total_brutto', aggregateFunc: AggregateFunction.AVG, label: 'Total Brutto', where: 'kw >202501' },
							{ fieldName: 'total_brutto', aggregateFunc: AggregateFunction.SUM, label: 'Total Brutto', where: 'kw >202501' },
							{ fieldName: 'total_netto', aggregateFunc: AggregateFunction.AVG, label: 'Total Netto', where: 'kw >202501' },
							{ fieldName: 'total_netto', aggregateFunc: AggregateFunction.SUM, label: 'Total Netto', where: 'kw >202501' },
							{ fieldName: 'total_storno', aggregateFunc: AggregateFunction.AVG, label: 'Total Storno', where: 'kw >202501' },
							{ fieldName: 'total_storno', aggregateFunc: AggregateFunction.SUM, label: 'Total Storno', where: 'kw >202501' },
						]}
					/>
				</>
			);
		case ImportDataType.akumaprime:
			return (
				<>
					<VntrControlChart store={agtAkumaPrimeStore} title="Anz. VTNR pro KW" timeDimension="kw" where="kw >202501" />
					<MultiFieldControlChart
						store={agtAkumaPrimeStore}
						timeDimension="kw"
						fields={[
							{ fieldName: 'einordnung_total', aggregateFunc: AggregateFunction.SUM, label: 'Einordnung Total', where: 'kw >202501' },
							{ fieldName: 'eingeordnet_total', aggregateFunc: AggregateFunction.SUM, label: 'Eingeordnet Total', where: 'kw >202501' },
							{ fieldName: 'einordnung_sach', aggregateFunc: AggregateFunction.SUM, label: 'Einordnung Sach', where: 'kw >202501' },
							{ fieldName: 'einordnung_leben', aggregateFunc: AggregateFunction.SUM, label: 'Einordnung Leben', where: 'kw >202501' },
							{ fieldName: 'einordnung_kranken', aggregateFunc: AggregateFunction.SUM, label: 'Einordnung Kranken', where: 'kw >202501' },
							{ fieldName: 'einordnung_fonds', aggregateFunc: AggregateFunction.SUM, label: 'Einordnung Fonds', where: 'kw >202501' },
							{ fieldName: 'einordnung_sonstige', aggregateFunc: AggregateFunction.SUM, label: 'Einordnung Sonstige', where: 'kw >202501' },

							{ fieldName: 'zu_kontaktierende_kunden', aggregateFunc: AggregateFunction.SUM, label: 'Zu kontaktierende Kunden', where: 'kw >202501' },
						]}
					/>
				</>
			);
		case ImportDataType.akumaplaner:
			return (
				<>
					<VntrControlChart store={agtAkumaPlanerStore} title="Anz. VTNR pro KW" timeDimension="kw" />
					<MultiFieldControlChart
						store={agtAkumaPlanerStore}
						timeDimension="kw"
						fields={[
							{ fieldName: 'zuweisbar', aggregateFunc: AggregateFunction.SUM, label: 'Zuweisbar' },
							{ fieldName: 'zugewiesen', aggregateFunc: AggregateFunction.SUM, label: 'Zugewiesen' },
							{ fieldName: 'gpwochen', aggregateFunc: AggregateFunction.SUM, label: 'GP Wochen' },
						]}
					/>
				</>
			);
		case ImportDataType.akumaaktionen:
			return (
				<>
					<VntrControlChart store={agtAkumaAktionenStore} title="Anz. VTNR pro KW" timeDimension="kw" />
					<MultiFieldControlChart
						store={agtAkumaAktionenStore}
						timeDimension="kw"
						fields={[
							{ fieldName: 'campaign_count_cust', aggregateFunc: AggregateFunction.AVG, label: 'Anzahl Aktionen (Kunden)' },
							{ fieldName: 'campaign_count_cont', aggregateFunc: AggregateFunction.AVG, label: 'Anzahl Aktionen (Vertrag)' },
							{ fieldName: 'campaign_number', aggregateFunc: AggregateFunction.COUNT_DISTINCT, label: 'Anzahl eindeutiger Aktionen' },
						]}
					/>
				</>
			);
		default:
			return <p>Keine Datenqualitätsanzeige für diesen Datentyp verfügbar</p>;
	}
});

export const ShowBmCountForDataType = observer((props: IShowBmForDataType) => {
	const { agtGoogleProfileStore, agtKvmStore, agtAmisNowStore, agtFacebookStore, agtInstagramStore, agtDigitalReportStore } = useStore();

	const tm = useMemo(() => {
		const model = new TableModel<IBmCount, string>();
		const cols: ITableColumn<IBmCount, string>[] = [
			{
				label: 'Berichtsmonat',
				path: 'bm',
			},
			{
				label: 'Anzahl VTNR',
				path: 'count',
				format: formatNum,
			},
		];
		model.setCols(cols);
		model.sortBy = 'bm';
		model.sortAsc = false;
		model.idProperty = 'bm';
		model.idType = 'string';
		return model;
	}, []);

	useEffect(() => {
		const loadData = async () => {
			let res: IBmCount[] = [];
			switch (props.dataType) {
				case ImportDataType.googleprofile:
					res = await agtGoogleProfileStore.countBmData();
					break;
				case ImportDataType.kvm:
					res = await agtKvmStore.countBmData();
					break;
				case ImportDataType.facebook:
					res = await agtFacebookStore.countBmData();
					break;
				case ImportDataType.instagram:
					res = await agtInstagramStore.countBmData();
					break;
				case ImportDataType.digitalreport:
					res = await agtDigitalReportStore.countBmData();
					break;
				case ImportDataType.amisnow:
					res = await agtAmisNowStore.countBmData();
					break;
			}
			tm.setRowData(res);
		};
		loadData();
	}, [props.dataType, agtGoogleProfileStore, agtKvmStore, agtFacebookStore, agtDigitalReportStore, agtInstagramStore, tm]);

	return (
		<>
			<p>Aktuelle Berichtsmonate in der DB:</p>
			<Table tm={tm} />
		</>
	);
});

interface IControlChartProps {
	store: AgtAnalyticsStore;
	title?: string;
	timeDimension?: TimeDimension;
	where?: string;
}

interface IFieldControlChartProps extends IControlChartProps {
	fieldName: string;
	aggregateFunc?: AggregateFunction;
	where?: string;
}

const formatTimeDimension = (value: number | string, timeDimension: TimeDimension): string => {
	if (value === undefined || value === null) return '';
	const str = value.toString();
	switch (timeDimension) {
		case 'bm':
			return str;
		case 'kw':
			return 'KW' + str;
		case 'year':
			return str;
		default:
			return str;
	}
};

const getTimeDimensionLabel = (timeDimension: TimeDimension): string => {
	switch (timeDimension) {
		case 'bm':
			return 'BM';
		case 'kw':
			return 'KW';
		case 'year':
			return 'Jahr';
		default:
			return 'Zeit';
	}
};

const getBarColor = (value: number, avg: number, upperLimit: number, lowerLimit: number): string => {
	if (value < lowerLimit || value > upperLimit) return '#dc3545'; // red
	const deviation = Math.abs(value - avg) / avg;
	if (deviation > 0.2) return '#fd7e14'; // orange
	return '#28a745'; // green
};

export const VntrControlChart = observer((props: IControlChartProps) => {
	const [data, setData] = useState<ITimeSeriesWithStats | null>(null);
	const [loading, setLoading] = useState(true);
	const timeDimension = props.timeDimension ?? 'bm';
	const chartRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		const loadData = async () => {
			setLoading(true);
			const res = await props.store.getVntrBmTimeSeries(timeDimension, props.where);
			setData(res);
			setLoading(false);
		};
		loadData();
	}, [props.store, timeDimension, props.where]);

	useEffect(() => {
		if (!chartRef.current || !data || data.data.length === 0) return;

		const chart = init(chartRef.current);

		// Prepare data
		const xAxisData = data.data.map((d) => formatTimeDimension(d.timeDimension, timeDimension));
		const barData = data.data.map((d) => ({
			value: d.value,
			itemStyle: {
				color: getBarColor(d.value, data.avg, data.upperLimit, data.lowerLimit),
				borderColor: d.isLatest ? '#000' : 'transparent',
				borderWidth: d.isLatest ? 2 : 0,
			},
		}));

		const option: EChartsOption = {
			animation: false,
			tooltip: {
				trigger: 'axis',
				formatter: (params: any) => {
					if (!Array.isArray(params) || params.length === 0) return '';
					const point = params[0];
					const dataIndex = point.dataIndex;
					const timeDimensionValue = data.data[dataIndex].timeDimension;
					return `${getTimeDimensionLabel(timeDimension)}: ${formatTimeDimension(timeDimensionValue, timeDimension)}<br/>${point.marker} ${formatNum(point.value)}`;
				},
			},
			grid: {
				left: 10,
				right: 10,
				top: 10,
				bottom: 60,
				containLabel: true,
			},
			xAxis: {
				type: 'category',
				data: xAxisData,
				axisLabel: {
					fontSize: 10,
					interval: 0,
					rotate: -45,
				},
			},
			yAxis: {
				type: 'value',
				axisLabel: {
					fontSize: 10,
					formatter: (value: number) => formatNum(value),
				},
			},
			series: [
				{
					name: 'Anz. VTNR',
					type: 'bar',
					data: barData,
					markLine: {
						silent: true,
						symbol: 'none',
						data: [
							{
								yAxis: data.avg,
								lineStyle: {
									color: '#666',
									type: [3, 3] as any,
									width: 1,
								},
								label: {
									formatter: 'Avg',
									fontSize: 10,
									position: 'insideEndTop',
								},
							},
							{
								yAxis: data.upperLimit,
								lineStyle: {
									color: '#dc3545',
									type: [5, 5] as any,
									width: 1,
								},
								label: {
									formatter: '+2σ',
									fontSize: 10,
									position: 'insideEndTop',
								},
							},
							{
								yAxis: data.lowerLimit,
								lineStyle: {
									color: '#dc3545',
									type: [5, 5] as any,
									width: 1,
								},
								label: {
									formatter: '-2σ',
									fontSize: 10,
									position: 'insideEndBottom',
								},
							},
						],
					},
				},
			],
		};

		chart.setOption(option);

		const handleResize = () => {
			chart.resize();
		};
		window.addEventListener('resize', handleResize);

		return () => {
			chart.dispose();
			window.removeEventListener('resize', handleResize);
		};
	}, [data, timeDimension]);

	if (loading) return <p>Lade Chart...</p>;
	if (!data || data.data.length === 0) return <p>Keine Daten</p>;

	return (
		<div className="control-chart">
			{props.title && (
				<p>
					<strong>{props.title}</strong>
				</p>
			)}
			<div className="chart-stats" style={{ display: 'flex', gap: '1.5rem', fontSize: '0.85rem', marginTop: '0.5rem', color: '#666' }}>
				<span>
					<strong>Aktuell:</strong> {formatNum(data.data.find((d) => d.isLatest)?.value ?? 0)}
				</span>
				<span>
					<strong>Avg:</strong> {formatNum(data.avg)}
				</span>
				<span>
					<strong>+2σ:</strong> {formatNum(data.upperLimit)}
				</span>
				<span>
					<strong>-2σ:</strong> {formatNum(data.lowerLimit)}
				</span>
			</div>
			<div ref={chartRef} style={{ width: '100%', height: 200 }} />
		</div>
	);
});

export const FieldControlChart = observer((props: IFieldControlChartProps) => {
	const [data, setData] = useState<ITimeSeriesWithStats | null>(null);
	const [loading, setLoading] = useState(true);
	const [title, setTitle] = useState(props.title);
	const timeDimension = props.timeDimension ?? 'bm';
	const chartRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		setTitle(props.title ? `${props.title} [${props.aggregateFunc}]` : '');
	}, [props.title, props.aggregateFunc]);

	useEffect(() => {
		const loadData = async () => {
			setLoading(true);
			const res = await props.store.getFieldBmTimeSeries(props.fieldName, props.aggregateFunc ?? AggregateFunction.SUM, timeDimension, props.where);
			setData(res);
			setLoading(false);
		};
		loadData();
	}, [props.store, props.fieldName, props.aggregateFunc, timeDimension, props.where]);

	useEffect(() => {
		if (!chartRef.current || !data || data.data.length === 0) return;

		const chart = init(chartRef.current);

		// Prepare data
		const xAxisData = data.data.map((d) => formatTimeDimension(d.timeDimension, timeDimension));
		const barData = data.data.map((d) => ({
			value: d.value,
			itemStyle: {
				color: getBarColor(d.value, data.avg, data.upperLimit, data.lowerLimit),
				borderColor: d.isLatest ? '#000' : 'transparent',
				borderWidth: d.isLatest ? 2 : 0,
			},
		}));

		const option: EChartsOption = {
			animation: false,
			tooltip: {
				trigger: 'axis',
				formatter: (params: any) => {
					if (!Array.isArray(params) || params.length === 0) return '';
					const point = params[0];
					const dataIndex = point.dataIndex;
					const timeDimensionValue = data.data[dataIndex].timeDimension;
					return `${getTimeDimensionLabel(timeDimension)}: ${formatTimeDimension(timeDimensionValue, timeDimension)}<br/>${point.marker} ${formatNum(point.value)} [${props.aggregateFunc}]`;
				},
			},
			grid: {
				left: 10,
				right: 10,
				top: 10,
				bottom: 60,
				containLabel: true,
			},
			xAxis: {
				type: 'category',
				data: xAxisData,
				axisLabel: {
					fontSize: 10,
					interval: 0,
					rotate: -45,
				},
			},
			yAxis: {
				type: 'value',
				axisLabel: {
					fontSize: 10,
					formatter: (value: number) => formatNum(value),
				},
			},
			series: [
				{
					name: props.fieldName,
					type: 'bar',
					data: barData,
					markLine: {
						silent: true,
						symbol: 'none',
						data: [
							{
								yAxis: data.avg,
								lineStyle: {
									color: '#666',
									type: [3, 3] as any,
									width: 1,
								},
								label: {
									formatter: 'Avg',
									fontSize: 10,
									position: 'insideEndTop',
								},
							},
							{
								yAxis: data.upperLimit,
								lineStyle: {
									color: '#dc3545',
									type: [5, 5] as any,
									width: 1,
								},
								label: {
									formatter: '+2σ',
									fontSize: 10,
									position: 'insideEndTop',
								},
							},
							{
								yAxis: data.lowerLimit,
								lineStyle: {
									color: '#dc3545',
									type: [5, 5] as any,
									width: 1,
								},
								label: {
									formatter: '-2σ',
									fontSize: 10,
									position: 'insideEndBottom',
								},
							},
						],
					},
				},
			],
		};

		chart.setOption(option);

		const handleResize = () => {
			chart.resize();
		};
		window.addEventListener('resize', handleResize);

		return () => {
			chart.dispose();
			window.removeEventListener('resize', handleResize);
		};
	}, [data, timeDimension, props.aggregateFunc, props.fieldName]);

	if (loading) return <p>Lade Chart...</p>;
	if (!data || data.data.length === 0) return <p>Keine Daten</p>;

	return (
		<div className="control-chart">
			{title && (
				<p>
					<strong>{title}</strong>
				</p>
			)}
			<div className="chart-stats" style={{ display: 'flex', gap: '1.5rem', fontSize: '0.85rem', marginTop: '0.5rem', color: '#666' }}>
				<span>
					<strong>Aktuell:</strong> {formatNum(data.data.find((d) => d.isLatest)?.value ?? 0)}
				</span>
				<span>
					<strong>Avg:</strong> {formatNum(data.avg)}
				</span>
				<span>
					<strong>+2σ:</strong> {formatNum(data.upperLimit)}
				</span>
				<span>
					<strong>-2σ:</strong> {formatNum(data.lowerLimit)}
				</span>
			</div>
			<div ref={chartRef} style={{ width: '100%', height: 200 }} />
		</div>
	);
});

interface IMultiFieldControlChartProps {
	store: AgtAnalyticsStore;
	fields: { fieldName: string; aggregateFunc?: AggregateFunction; label?: string; where?: string }[];
	timeDimension?: TimeDimension;
}

export const MultiFieldControlChart = observer((props: IMultiFieldControlChartProps) => {
	return (
		<div className="multi-field-control-chart">
			{props.fields.map((field, idx) => (
				<FieldControlChart
					key={idx}
					store={props.store}
					fieldName={field.fieldName}
					aggregateFunc={field.aggregateFunc}
					title={field.label || field.fieldName}
					timeDimension={props.timeDimension}
					where={field.where}
				/>
			))}
		</div>
	);
});
